import axios from 'axios';

const getSingleLeftedCartItemApi = async (paramsFilter, token, langIsoCode) => {
  try {
    const url = `/leftCart/single?store_id=${
      paramsFilter?.store_id || ''
    }&user_id=${paramsFilter?.user_id || ''}&page=${paramsFilter?.page || ''}`;
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getSingleLeftedCartItemApi;
